<button [ngClass]="{'hover': isHover, 'isgreen': isGreen, 'hover-green': isHoverGreen, 'iswhite': isWhite, 'disabled': disabled}" [disabled]="disabled">
    <svg-icon src="{{imgUrl}}"></svg-icon><span *ngIf="isText">{{buttonText}}</span>
</button>